import {
  api,
  IRequest,
  IResponse,
  ServiceError,
} from '@/services/api';
import { CurrencyCode } from '@/constants/general';
import {
  IBookingRules,
  IPublicWebsite,
  IUser,
  IWebsiteConfig,
  IWebsiteAnalyticCredential,
  VideoProvider,
} from '@/entities';

interface IGetPublicWebsiteRequestParams {
  userId: string;
}

interface IGetPublicWebsiteResponseBody {
  user: IUser;
  currency: CurrencyCode;
  timezone: string;
  configuration?: IWebsiteConfig;
  path?: string;
  bookingRules?: IBookingRules;
  paymentsConnected?: boolean;
  analyticCredentials?: IWebsiteAnalyticCredential[];
  videoProvider?: VideoProvider;
}

export const getPublicWebsite = async (
  { params }: IRequest<IGetPublicWebsiteRequestParams>,
): IResponse<IPublicWebsite> => {
  try {
    const { data } = await api.get<IGetPublicWebsiteResponseBody>(`/users/public/${params.userId}/data`);

    return {
      user: data.user,
      currency: data.currency,
      timezone: data.timezone,
      configuration: data.configuration,
      domain: data.path,
      bookingRules: data.bookingRules,
      isPaymentAccountConnected: data.paymentsConnected,
      analyticCredentials: data.analyticCredentials,
      videoProvider: data.videoProvider,
    };
  } catch (err) {
    throw new ServiceError(err);
  }
};
